var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFranceFlag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09699 4.82812C0.93882 4.82812 0 5.76695 0 6.92512V21.076C0 22.2341 0.93882 23.173 2.09699 23.173H9.33335V4.82812H2.09699Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6675 4.82812H9.33398V23.173H18.6675V4.82812Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9024 4.82812H18.666V23.1729H25.9024C27.0605 23.1729 27.9994 22.2341 27.9994 21.0759V6.92512C27.9994 5.76695 27.0605 4.82812 25.9024 4.82812Z",
    fill: "#FF4B55"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFranceFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-france-flag.22cfab21.svg";
export { ForwardRef as ReactComponent };